import React from "react";

import TwitterCreateDest from "pages/Destinations/TwitterCreateDest";

import CreateTwitterDestinationPopup from "components/CreateTwitterDestinationPopup";

/** X OAuth popup, then pixel / account selection for CAPI or Pixel. */
const TwitterDestinationForm = ({
    destinationCode,
    twitter,
    oauthData,
    setOauthData,
    setIsButtonLoader,
}) => {
    const { activeAccount } = twitter;

    return (
        <>
            {!activeAccount.showCreateForm && (
                <CreateTwitterDestinationPopup
                    isAuthData={oauthData}
                    setIsAuthData={setOauthData}
                    type={destinationCode}
                    setModalLoading={setIsButtonLoader}
                />
            )}
            {activeAccount.showCreateForm && (
                <TwitterCreateDest
                    key={destinationCode}
                    authData={oauthData}
                    setTwPixelId={activeAccount.setPixelId}
                    setTwInstallId={activeAccount.setInstallId}
                    setTwAccountId={activeAccount.setAccountId}
                />
            )}
        </>
    );
};

export default TwitterDestinationForm;
